export default __webpack_public_path__ + "1be9e31739937327b2491c9a2e6dd6a1.png";